var _circle, _path, _path2, _path3, _path4, _path5, _circle2, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnterpriseSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "#FFEBEE",
    stroke: "#F44336",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16l12 4v8c0 8-12 16-12 16s-12-8-12-16v-8l12-4z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24h8v8h-8v-8z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 26h4v2h-4v-2z",
    fill: "#F44336"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30h4v1h-4v-1z",
    fill: "#F44336"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 32h4v1h-4v-1z",
    fill: "#F44336"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 36,
    r: 1,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20l4-2 4 2 4-2 4 2 4-2 4 2",
    stroke: "#F44336",
    strokeWidth: 1.5,
    fill: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 44l4-2 4 2 4-2 4 2 4-2 4 2",
    stroke: "#F44336",
    strokeWidth: 1.5,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseSecurity);
export default __webpack_public_path__ + "static/media/enterprise-security.d2b42767e37a2befa7f7308860f9cd84.svg";
export { ForwardRef as ReactComponent };